import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE, SEARCH_REQUEST_BYKEYS_FORCE} from '../../../../store/search'
import {SearchEntities} from '../../../../common/enums'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)

@Component
class TicketMandateSelector extends Vue {
  /**
   *
   */
  dtTemporaryContractors: any[] | null;

  @Prop({default: () => [], type: [Array]})
  value: number[]
  @Prop({default: () => [], type: [Array]})
  rules: any[]
  @Prop({ default: false, type: [Boolean] })
  disabled: false
  @Prop({ default: [], type: [Array] })
  block: number[]
  @Watch('block')
  blockChange () {
    this.loadContractor()
  }

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetResources: (payload: { entity: SearchEntities[], query?: string, block?: number[] }) => Promise<any[]>;
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetIndependentContractors: (payload: { keys: string[], force?: boolean }) => Promise<any[]>;

  @SearchStore.Getter contractors: any[];
  @SearchStore.Getter caretakers: any[];

  // @SearchStore.Getter independent_contractors: any[];

  constructor () {
    super()
    this.dtTemporaryContractors = []
  }

  get vModel (): number[] {
    return this.value
  }

  set vModel (value: number[]) {
    this.$emit('input', value)
  }

  get lblSetting () {
    return {
      ...require('@/locales/ticket').default
    }
  }

  get resources () {
    /*
    const ics = (this.contractors || []).map(x => {
      return {lastname: x.lastname, firstname: x.firstname, id: x.id, text: `${x.firstname} ${x.lastname}`}
    })
    const cts = (this.caretakers || []).map(x => {
      return {lastname: x.lastname, firstname: x.firstname, id: x.id, text: `${x.firstname} ${x.lastname}`}
    })
    return [

      {header: this.$t(this.lblSetting.ticketCaretakers)},
      {divider: true},
      ...cts,
      {divider: true},
      {header: this.$t(this.lblSetting.ticketIndependentContractors)},
      ...ics
    ]
    */
    return this.dtTemporaryContractors
  }

  mounted () {
    /*
    this.storeGetIndependentContractors({
      keys: [SearchEntities.IndependentContractor, SearchEntities.CareTaker],
      force: true
    })
      .catch(error => console.log(error))
    */
    this.loadContractor()
  }

  handleFilter (key: string) {
    return this.storeGetResources({
      entity: [SearchEntities.Contractor],
      query: key,
      block: this.block
    })
  }

  loadContractor () {
    this.storeGetResources({
      entity: [SearchEntities.Contractor],
      block: this.block
    }).then(res => {
      this.dtTemporaryContractors = res
    })
  }
}

export default TicketMandateSelector



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-mandate-selector/index.ts